// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2FlqM","head":"ProcedureTableInfo_head__3jbVo"};